/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { baseRecommendationSourceRequestSchema } from "./baseRecommendationSourceRequestSchema.ts";

export const createRecommendationsRequestSchema = z
	.object({
		groups: z.array(baseRecommendationSourceRequestSchema).optional(),
		products: z.array(baseRecommendationSourceRequestSchema).optional(),
	})
	.describe("Сериализатор создания рекомендаций.");
